module.exports = __webpack_public_path__ + "static/media/slide6.cf5c581e.svg";